<template>
    <div>
      <common-dialog
        ref="dialog"
        width="700px"
        :show-save-button="$permission.canEdit()"
        unit="首页板块"
        edit-title
        id-key="RecordId"
        :data="data"
        form-label-width="85px"
        :form-rules="rules"
        :save-func="api.save"
        @create-opened="onCreateOpened"
        @edit-opened="onEditOpened"
        close-on-saved
        :before-save="onBeforeSave"
        @closed="onClosed"
        @close-saved="$emit('close-saved')"
      >
        <template slot="form">
          <el-row>
            <el-col :span="isMB?24:12">
              <el-form-item label="板块名称" prop="SectionName">
                <el-input v-model="data.SectionName" placeholder="请填写板块名称" clearable></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="isMB?24:12">
              <el-form-item label="板块类别" prop="SectionType">
                <el-select v-model="data.SectionType" placeholder="请选择板块类别" clearable>
                  <el-option :value="1" label="广告区域"></el-option>
                  <el-option :value="2" label="商品区域"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <!-- <el-row>
            <el-col :span="isMB?24:12"  v-if="data.SectionType==2">
              <el-form-item label="商品行数" prop="Rows">
                <el-input v-model="data.Rows" type="number" v-int placeholder="请填写商品展示行数" clearable></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="isMB?24:12" v-if="data.SectionType==2">
                <el-form-item label="商品列数" prop="Cols">
                <el-input v-model="data.Cols" type="number" v-int placeholder="请填写商品展示列数" clearable></el-input>
             </el-form-item>
            </el-col>
          </el-row> -->

          <el-row>
            <el-col :span="isMB?24:12">
              <el-form-item label="序号" prop="OrderId">
                <el-input-number v-model="data.OrderId" :min="0" />
              </el-form-item>
            </el-col>
            <el-col :span="isMB?24:12">
              <el-form-item label="状态" prop="State">
                <el-radio-group v-model="data.State">
                  <el-radio :label="1">启用</el-radio>
                  <el-radio :label="0">停用</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-row>
          
        </template>
        <template #footer v-if="!$permission.canEdit()">
           <el-button @click="close">关 闭</el-button>
      </template>
      </common-dialog>
    </div>
  </template>
  <script>
  import editDialogMixin from "@/mixins/editDialog";
  import commonDialog from "@/components/common/dialog";
  import singlePicUpload from "@/components/common/photo/singleUpload";
  
  export default {
    mixins: [editDialogMixin],
    components: {
      commonDialog,
      singlePicUpload
    },
    data() {
      return {
        data: {
          RecordId: 0,
          SectionName: "",
          SectionType: "",
          Rows: 4,
          Cols: 4,
          OrderId: 0,
          State: 1,
        },
        api: require("@/api/mall/section.js").default,
        isMB: this.$store.state.isMB,
        rules: {
          SectionName: [{ required: true, message: "板块名称不能为空" }],
          SectionType: [{ required: true, message: "板块类别不能为空" }],
          //Rows: [{ required: true, message: "行数不能为空" }],
          //Cols: [{ required: true, message: "列数不能为空" }],
          // IfShowIndex: [{ required: true, message: "是否展示在首页不能为空" }],
          OrderId: [{ required: true, message: "序号不能为空" }],
        },
      };
    },
    methods: {
      onCreateOpened(row) {
        this.api.getMaxOrderId().then(res => {
          if(res.Code==0) this.data.OrderId = res.Data;
        })
      },
      onEditOpened(row) {
        
      },
      onBeforeSave() {
        
      },
      onClosed() {
  
      },
    },
  };
  </script>